// extracted by mini-css-extract-plugin
export var cardLayout = "_1y-1";
export var paginationContainer = "_1y-0";